import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

export default function DashboardSidebar() {
    const [clicks, setClicks] = useState(0);

    // Load banner click count
    useEffect(() => {
        const stored = localStorage.getItem("wifeRecipeBannerClicks");
        if (stored) setClicks(Number(stored));
    }, []);

    // Reset total count
    const resetCount = () => {
        localStorage.removeItem("wifeRecipeBannerClicks");
        setClicks(0);
    };

    // Clear unique user flag
    const resetUserFlag = () => {
        localStorage.removeItem("wifeRecipeBannerClicks");
        alert("Unique user flag cleared");
    };

    return (
        <aside className="w-64 bg-white border-r shadow-sm">
            <div className="p-5 font-bold text-xl border-b text-red-600">
                Admin Panel
            </div>

            <nav className="p-4 space-y-3">
                <Link
                    to="/dashboard/articles"
                    className="block px-4 py-2 rounded hover:bg-red-50 text-gray-700"
                >
                    📄 Articles
                </Link>

                <Link
                    to="/dashboard/articles/create"
                    className="block px-4 py-2 rounded hover:bg-red-50 text-gray-700"
                >
                    ✍️ Create Article
                </Link>

                {/* 🔥 Banner Analytics */}
                <div className="mt-6 border-t pt-4">
                    <div className="text-sm font-semibold text-gray-600 mb-2">
                        📊 Banner Analytics
                    </div>

                    <div className="px-4 py-2 text-sm bg-gray-50 rounded mb-2">
                        Total Clicks:{" "}
                        <span className="font-bold text-green-600">
                            {clicks}
                        </span>
                    </div>

                    <button
                        onClick={resetCount}
                        className="w-full px-4 py-2 text-sm rounded bg-red-500 text-white hover:bg-red-600 mb-2"
                    >
                        🧹 Reset Click Count
                    </button>

                    <button
                        onClick={resetUserFlag}
                        className="w-full px-4 py-2 text-sm rounded bg-gray-600 text-white hover:bg-gray-700"
                    >
                        🔄 Clear User Flag
                    </button>
                </div>
            </nav>
        </aside>
    );
}
